module.exports = __webpack_public_path__ + "img/logo.ee9416d4.png";